module.exports = __webpack_public_path__ + "img/glogo205.df506cea.png";